import React from 'react';
import styled from 'styled-components';

const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
`;

const ModalContent = styled.div`
  background-color: white;
  padding: 30px;
  border-radius: 10px;
  max-width: 500px;
  width: 90%;
  box-shadow: 0 5px 15px rgba(0, 0, 0, 0.3);
  text-align: center;
  position: relative;
`;

const Title = styled.h2`
  color: #333;
  margin-bottom: 20px;
  font-family: 'Permanent Marker', cursive, sans-serif;
`;

const Description = styled.p`
  color: #555;
  margin-bottom: 20px;
  line-height: 1.6;
`;

const Instructions = styled.div`
  margin: 20px 0;
  text-align: left;
  padding: 15px;
  background-color: #f9f9f9;
  border-radius: 5px;
`;

const InstructionItem = styled.div`
  margin-bottom: 10px;
  display: flex;
  align-items: flex-start;
`;

const Number = styled.span`
  background-color: #4a90e2;
  color: white;
  width: 24px;
  height: 24px;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-right: 10px;
  flex-shrink: 0;
`;

const Text = styled.span`
  flex: 1;
`;

const Button = styled.button`
  background-color: #4a90e2;
  color: white;
  border: none;
  padding: 12px 24px;
  border-radius: 5px;
  cursor: pointer;
  font-weight: bold;
  transition: background-color 0.3s;
  
  &:hover {
    background-color: #357abd;
  }
`;

const WelcomeModal = ({ onClose }) => {
  return (
    <ModalOverlay onClick={onClose}>
      <ModalContent onClick={(e) => e.stopPropagation()}>
        <Title>Welcome to Healing Out Loud</Title>
        <Description>
          This is a space for sharing your healing journey with others. 
          Browse through messages from people around the world and add your own reflections.
        </Description>
        
        <Instructions>
          <InstructionItem>
            <Number>1</Number>
            <Text>Drag the cork board to explore messages from others</Text>
          </InstructionItem>
          <InstructionItem>
            <Number>2</Number>
            <Text>Click "Share Your Story" to add your own message</Text>
          </InstructionItem>
          <InstructionItem>
            <Number>3</Number>
            <Text>Choose to share your name or remain anonymous</Text>
          </InstructionItem>
        </Instructions>
        
        <Description>
          Remember, this is a supportive community. Be kind and respectful in your messages.
        </Description>
        
        <Button onClick={onClose}>Get Started</Button>
      </ModalContent>
    </ModalOverlay>
  );
};

export default WelcomeModal; 